/**
 * Выбор адреса бэкенда.
 *
 * Раньше песочница определялась через `hostname.startsWith("sandbox-admin.")`.
 * На стендовых доменах вида `pr-sandbox-admin.payfinzora.com` такая проверка
 * не срабатывает, и стенд молча уходил бы в боевой API — поэтому здесь мы
 * ищем слово "sandbox" в любой позиции имени хоста.
 *
 * Порядок приоритетов:
 *   1. REACT_APP_API_BASE_URL — жёсткое закрепление адреса на сборку;
 *   2. dev-прокси `/api` в режиме разработки (обходит CORS);
 *   3. определение по домену.
 */

/** Боевой контур. Переопределяется на сборке. */
const PROD_API =
  process.env.REACT_APP_API_URL || "https://api.payfinzora.com";

/** Песочница. Переопределяется на сборке. */
const SANDBOX_API =
  process.env.REACT_APP_SANDBOX_API_URL || "https://sandbox.payfinzora.com";

/** Совпадает с sandbox-admin, pr-sandbox-admin, sandbox-merchant и т.д. */
export const isSandboxHost = (hostname: string): boolean =>
  /(^|[.-])sandbox([.-]|$)/i.test(hostname);

export const resolveApiBaseUrl = (): string => {
  if (process.env.REACT_APP_API_BASE_URL) {
    return process.env.REACT_APP_API_BASE_URL;
  }

  if (process.env.NODE_ENV === "development") {
    return "/api";
  }

  return isSandboxHost(window.location.hostname) ? SANDBOX_API : PROD_API;
};
